import { useEffect, useState } from 'react';

import { useIntl } from 'react-intl';

import { useUserContext } from '@/components/user-context/user-context-provider';
import { useTheme } from '@/libraries/design/utils/dark-theme-provider';
import { useLocalizedHref } from '@/libraries/web-framework/src/localization/use-localized-href';
import { LogoV3 } from '@/libraries/wpl/foundations/src/logo-v3';
import { ProductPageNav } from '@/patterns/global-nav/src/product-page-nav';

import { useJiraSitesContext } from '../jira-sites-provider/jira-sites-provider';

const JiraLogo = () => {
	const { isDarkTheme } = useTheme();
	return <LogoV3 brand="jira" type="logo" appearance="brand" darkTheme={isDarkTheme} />;
};

const SoftwareJiraLoggedInNavbar = () => {
	const intl = useIntl();
	const logoUrl = useLocalizedHref('/software/jira');
	const { profile } = useUserContext();
	const { jiraSitesFromAgg } = useJiraSitesContext();
	const [siteUrl, setSiteUrl] = useState('');
	useEffect(() => {
		//TODO: Probably a good spot for another UFO
		// e.g. if there are no resources for us to use
		const site = profile.attributes?.existingSites[0];
		let tempSiteUrl = site?.url;
		if (jiraSitesFromAgg?.jira.allJiraProjects.edges.length === 1) {
			tempSiteUrl = jiraSitesFromAgg?.jira.allJiraProjects?.edges[0]?.node?.webUrl;
		}
		setSiteUrl(tempSiteUrl ?? '');
	}, [
		jiraSitesFromAgg?.jira.allJiraProjects.edges,
		jiraSitesFromAgg?.jira.allJiraProjects.edges.length,
		profile.attributes?.existingSites,
		profile.attributes?.existingSites.length,
	]);

	const goToLoggedInJira = () => {
		window.location.assign(siteUrl);
	};

	return (
		<ProductPageNav
			productLogoUrl={logoUrl}
			productLogo={<JiraLogo />}
			productLogoAriaLabel={intl.formatMessage({
				id: 'wacJiraSoftwareNavigation.logo-label',
				defaultMessage: 'Jira Software logo',
			})}
			mobileCtaText={intl.formatMessage({
				id: 'JiraSoftwarePageTemplate.navbar.goToJira',
				defaultMessage: 'Go to Jira',
			})}
			mobileCtaOnClick={goToLoggedInJira}
			mobileLogo={<JiraLogo />}
			navigationTrynowCtaText={intl.formatMessage({
				id: 'JiraFeatureSoftwarePageTemplate.navbar.goToJira',
				defaultMessage: 'Go to Jira',
			})}
			navigationTrynowCtaOnClick={goToLoggedInJira}
			productPageNavLinks={[]}
			mobileLinksSections={[]}
			isShowSearchButton={false}
			isShowAppSwitcher={false}
			isShowTabletDropdown={false}
		/>
	);
};

export default SoftwareJiraLoggedInNavbar;
